/* RIPNDIP navigation helpers
 * - pageswap: skip the View Transition when leaving for cart / checkout / account, or when a drawer
 *   (menu, cart, search) is open: the browser then keeps the live page, drawer and all, until the next
 *   document paints. Stripping the drawer here instead made the captured old snapshot show the bare
 *   page for the crossfade, a visible "menu closes, old page flashes" on every drawer link tap. Open
 *   modals are still dropped from the snapshot.
 * - pagereveal: record that a transition ran (QA hook in sessionStorage).
 * - pageshow: refresh the cart bubble when the page is restored from the back/forward cache.
 * - hover/touch prefetch for browsers without Speculation Rules (Safari, Firefox).
 */
(function () {
  'use strict';
  var SKIP = /^\/(cart|checkout|checkouts|account)(\/|$)/;

  /* A skipped transition (ours below, or the browser's own when the next page is slow or hidden) rejects
     its promises with AbortError. Nothing awaits them, so without these handlers every skip is reported as
     an unhandled rejection. The navigation itself is unaffected either way. */
  function quiet(vt) {
    ['ready', 'finished', 'updateCallbackDone'].forEach(function (k) {
      try { if (vt[k] && vt[k].catch) vt[k].catch(function () {}); } catch (err) {}
    });
  }

  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    quiet(e.viewTransition);
    var dest = e.activation && e.activation.entry ? e.activation.entry.url : '';
    try {
      if (SKIP.test(new URL(dest, location.href).pathname)) { e.viewTransition.skipTransition(); return; }
    } catch (err) {}
    if (document.documentElement.classList.contains('js-drawer-open') || document.querySelector('.drawer--is-open')) {
      e.viewTransition.skipTransition();
      return;
    }
    document.querySelectorAll('.modal--is-active').forEach(function (m) { m.classList.remove('modal--is-active'); });
  });

  window.addEventListener('pagereveal', function (e) {
    if (!e.viewTransition) return;
    quiet(e.viewTransition);
    try { sessionStorage.setItem('rd_vt_revealed', String(Date.now())); } catch (err) {}
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.drawer a.is-loading').forEach(function (a) { a.classList.remove('is-loading'); });
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
          el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      })
      .catch(function () {});
  });

  /* Prefetch fallback: only where Speculation Rules are unsupported. */
  var supportsRules = typeof HTMLScriptElement !== 'undefined' &&
    typeof HTMLScriptElement.supports === 'function' && HTMLScriptElement.supports('speculationrules');
  if (supportsRules) return;

  var seen = {};
  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.origin !== location.origin) return false;
    if (a.hasAttribute('data-no-prefetch') || a.hasAttribute('download')) return false;
    if (a.search || a.hash) return false;
    var p = a.pathname;
    if (SKIP.test(p) || /^\/search/.test(p)) return false;
    if (p !== '/' && !/^\/(collections|products|pages|blogs)\//.test(p)) return false;
    if (p === location.pathname) return false;
    return true;
  }
  function prefetch(url) {
    if (seen[url]) return;
    seen[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }
  var timer = null;
  document.addEventListener('mouseover', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!eligible(a)) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(a.href); }, 80);
  }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (eligible(a)) prefetch(a.href);
  }, { passive: true });
})();
